export function getCssSizeValue(value?: number | string, fallback?: number | string): string {
  if (typeof value === "number") {
    return `${value}px`;
  }
  if (typeof fallback === "number") {
    return `${fallback}px`;
  }
  return value ?? fallback ?? "0";
}
